export const CARVING_SETSTATE = "CARVING_SETSTATE";
export const DOCUMENT_INIT = "DOCUMENT_INIT";
export const DOCUMENT_GETSCREENTEXT = "DOCUMENT_GETSCREENTEXT";
export const DOCUMENT_GETAPPDOCLIST = "DOCUMENT_GETAPPDOCLIST";
export const DOCUMENT_GETAPPDOCLISTFILE = "DOCUMENT_GETAPPDOCLISTFILE";
export const DOCUMENT_GETAPPLOOKUPVALUES = "DOCUMENT_GETAPPLOOKUPVALUES";